export default {
  auth: false,
  token: null,
  user: null,
  role: null
}